import React, { Component } from "react";
import axios from "axios";
import { Card, Grid, MenuItem, TextField } from "@mui/material";
import { Navigate } from "react-router-dom";

import Constants from "Helpers/Constants";
import init from "Helpers/WindowToken";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDSnackbar from "components/MDSnackbar";
import MDTypography from "components/MDTypography";

export default class AddExam extends Component {
  state = {
    exam_name: "",
    status: "active",
    exam_image: null,
    notification: false,
    message: "",
    noticolor: "success",
    redirect: false,
  };

  handleInput = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  handleSubmit = (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("exam_name", this.state.exam_name);
    formData.append("status", this.state.status);
    if (this.state.exam_image) {
      formData.append("exam_image", this.state.exam_image);
    }

    if (init() === "success") {
      axios
        .post(Constants.postUrls.createExam, formData)
        .then((resp) => {
          this.setState({
            notification: true,
            noticolor: "success",
            message: resp?.data?.message || "Exam created successfully.",
          });
          setTimeout(() => {
            this.setState({ notification: false, message: "", redirect: true });
          }, 2500);
        })
        .catch((err) => {
          this.setState({
            notification: true,
            noticolor: "error",
            message: err?.response?.data?.message || "Unable to create exam.",
          });
          setTimeout(() => {
            this.setState({ notification: false, message: "" });
          }, 3000);
        });
    }
  };

  render() {
    if (this.state.redirect) {
      return <Navigate to="/exams" />;
    }

    return (
      <DashboardLayout>
        <DashboardNavbar />
        <MDBox pt={6} pb={3}>
          <Card>
            <MDBox
              mx={2}
              mt={-3}
              py={3}
              px={2}
              variant="gradient"
              bgColor="info"
              borderRadius="lg"
              coloredShadow="info"
            >
              <MDTypography variant="h6" color="white">
                Create Exam
              </MDTypography>
            </MDBox>
            <MDBox py={3} px={2}>
              <form onSubmit={this.handleSubmit}>
                <Grid container spacing={2}>
                  <Grid item xs={12} md={6}>
                    <TextField
                      type="text"
                      label="Exam Name"
                      name="exam_name"
                      value={this.state.exam_name}
                      onChange={this.handleInput}
                      style={{ width: "100%" }}
                    />
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <TextField
                      select
                      label="Status"
                      name="status"
                      value={this.state.status}
                      onChange={this.handleInput}
                      style={{ width: "100%" }}
                    >
                      <MenuItem value="active">Active</MenuItem>
                      <MenuItem value="inactive">Inactive</MenuItem>
                    </TextField>
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <TextField
                      type="file"
                      label="Exam Image"
                      name="exam_image"
                      focused
                      onChange={(e) =>
                        this.setState({
                          exam_image: e.target.files?.[0] || null,
                        })
                      }
                      style={{ width: "100%" }}
                    />
                  </Grid>
                </Grid>

                <Grid align="left" mt={2}>
                  <MDButton variant="contained" size="small" color="info" type="submit">
                    Create
                  </MDButton>
                </Grid>
              </form>
            </MDBox>

            <MDSnackbar
              color={this.state.noticolor}
              icon="notifications"
              title="AgriQuiz"
              content={this.state.message}
              dateTime="Just now"
              open={this.state.notification}
            />
          </Card>
        </MDBox>
      </DashboardLayout>
    );
  }
}
